(function (_) {
    'use strict';

    _['LOYALTY.KEY'] = 'Loyalty Cards';
    _['LOYALTY.EMPTY-LIST'] = 'Loyalty cards empty list';
    _['LOYALTY.VALID-FROM'] = 'From: ';
    _['LOYALTY.VALID-UNTIL'] = 'Until: ';
    _['LOYALTY.NO-LIMIT'] = 'Limitless';
    _['LOYALTY.CONDITIONS'] = 'Conditions';
    _['LOYALTY.CANCEL'] = 'Cancel';
    _['LOYALTY.ACCEPT'] = 'Accept';
    _['LOYALTY.EXCEPTIONS-TITLE'] = 'Exceptions';
    _['LOYALTY.PERIOD-VALIDITY'] = 'Period of validity';
    _['LOYALTY.HOW-STAMP-TITLE'] = 'How stamping: ';
    _['LOYALTY.HOW-STAMP-CONTENT'] = 'Show your QR code or enter the validation code in your device, please! ';
    _['LOYALTY.HOW-STAMP-CONTENT-ONLY-CODE'] = 'Enter the validation code in your device, please! ';
    _['LOYALTY.DAILY-LIMIT'] = 'You have exceeded the daily limit';
    _['LOYALTY.VALID-CODE'] = 'Valid code';
    _['LOYALTY.INVALID-CODE'] = 'Invalid code';
    _['LOYALTY.GIFT-FREEBIENAME'] = 'Congrats! You have now a free:';
    _['LOYALTY.CODE-PLACEHOLDER'] = 'Enter code';

}(translations['en']));



// WEBPACK FOOTER //
// ./src/app/modules/loyalty/lang/loyalty-lang_en.js